import { PageHead } from "@getaways/extranet-ui";
import { useCan } from "../lib/access";
import { FilterBar, useFilters, useOptions } from "../lib/filters";
import { filterOf, ResultTable } from "../lib/query";

/** Suppliers and bed banks (docs/36 §7): what each one sold for us, at what cost, and the mix per destination. */
export function SuppliersPage() {
  const money = useCan()("money:read");
  const [filters, setFilters] = useFilters("suppliers");
  const options = useOptions();
  const f = filterOf(filters);
  const m = ["item_orders", "services", "item_sell", ...(money ? ["item_cost", "item_margin", "item_margin_pct"] : [])];
  return (
    <>
      <PageHead title="Suppliers" sub="Every supplier and bed bank, by product and destination." />
      <div className="card" style={{ padding: 0, marginBottom: 14 }}>
        <FilterBar filters={filters} onChange={setFilters} options={options} />
      </div>
      <ResultTable title="By supplier" spec={{ table: "items", measures: m, dimensions: ["supplier", "vertical"], filter: f }} />
      <div style={{ height: 14 }} />
      <div className="grid-2">
        <ResultTable title="Bed banks per destination" spec={{ table: "items", measures: ["item_orders", "room_nights", "item_sell", "adr"], dimensions: ["destination", "supplier"], filter: { ...f, verticals: ["hotel"] }, sort: "destination", dir: "asc" }} />
        <ResultTable title="By board" spec={{ table: "items", measures: ["item_orders", "room_nights", "adr"], dimensions: ["board"], filter: { ...f, verticals: ["hotel"] } }} />
      </div>
    </>
  );
}
